import { UserTypes } from '../../types/Account'
import { JsonWebToken, JWTHeader, JWTPayload, Resource } from './types'
import { isValidJWTHeader, isValidJWTPayload } from './validators'

// decodeJwt decodes a JSON web token into its header, payload, and signature
export const decodeJwt = (token: string): JsonWebToken => {
  const parts = token.split('.')
  if (parts.length !== 3) {
    throw new Error('Invalid JWT format')
  }

  try {
    const header: JWTHeader = JSON.parse(atob(parts[0]))
    const payload: JWTPayload = JSON.parse(atob(parts[1]))
    const signature = parts[2]

    if (!isValidJWTHeader(header) || !isValidJWTPayload(payload)) {
      throw new Error('Invalid JWT')
    }

    return { header, payload, signature }
  } catch (err) {
    if (err instanceof Error) {
      throw new Error('Failed to parse JWT: ' + err.message)
    } else {
      throw new Error('Failed to parse JWT: Unknown error')
    }
  }
}

// getUserType determines the user type from the JWT payload
export const getUserType = (payload: JWTPayload): UserTypes => {
  const sub = payload.sub.split(':')[1]
  if (sub === 'playerid') {
    return UserTypes.requestor
  } else if (sub === 'email-hash') {
    return UserTypes.approver
  }
  return UserTypes.unk
}

// isExpired checks if the JWT is expired
export const isExpired = (exp: number): boolean => {
  const currentTime = new Date()
  const expTime = new Date(exp * 1000)
  return expTime <= currentTime
}

// extractAccountIDFromJwt extracts the account ID from the JWT payload
export const extractAccountIDFromJwt = (jwt: JsonWebToken | null): string => {
  if (jwt && jwt.payload) {
    const resources = jwt.payload.rsc_v1.filter((resc: Resource) => resc.k === 'player-id')

    // if there are 0 or more than 1 resource, we can not determine player so return ''
    return resources.length === 1 ? resources[0].v : ''
  }
  return ''
}
